import service from '@/services/modules/cobranza/credito'

export default {
  CREDITO_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      service.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  CREDITO_SALDO_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      service.findAllSaldo(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  CREDITO_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      service.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  AMORTIZAR_CREDITO_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      service.updateCreditoAmortizar(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  AMORTIZAR_CREDITO_LIST(_, params) {
    return new Promise((resolve, reject) => {
      service.findAllAmortizar(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
